// can't use custom hooks inside the loop, so we use axios directly instead
// import {useUpdate} from "../../hooks/useUpdate";
import { message } from "antd";
import axios from "axios";

export const AssetImageBatchUpload = (payload, setProgressInfo, onFinish) => {
  //payload is an array of FormData

  const setProgressValue = (index, obj) => {
    setProgressInfo((prevState) => {
      const newState = prevState.map((x, i) => {
        return { ...x };
      });
      newState[index] = { ...newState[index], ...obj };
      return newState;
    });
  };

  const length = payload.length;
  //this is a recursive function for processing each data
  const sendFormData = async (index) => {
    try {
      setProgressValue(index, { percent: 20, status: "processing" });

      //TODO: catch network error

      // setTimeout(() => {
      //     throw "Network timeout";
      // }, 0);
      const data = await axios.put(
        `${process.env.REACT_APP_API_URL}/assets/medias`,
        payload[index],
        { headers: { session: localStorage.getItem("session_id") } }
      );
      // console.log("STATUS");
      // console.log(data);
      if (data.status === 200) {
        // message.success(`Entry ${index} updated`, 2);
        setProgressValue(index, {
          percent: 100,
          status: "success",
          done: true,
        });
      } else {
        message.error(`Entry ${index} failed to update`, 3);
        setProgressValue(index, {
          status: "failed",
          done: true,
        });
      }
      //re-call this function
      if (index < length - 1) sendFormData(index + 1);
      onFinish();
    } catch (err) {
      message.error(`Failed to update, please try again`, 3);
      console.log("ERROR: ", err.stack);
      setProgressValue(index, {
        status: "failed",
        done: true,
      });
      //re-call this function
      if (index < length - 1) sendFormData(index + 1);

      onFinish();
    }
  };
  payload.length > 0 && sendFormData(0);
};
